import { render, staticRenderFns } from "./RfidLayout.vue?vue&type=template&id=28edc252"
import script from "./RfidLayout.vue?vue&type=script&lang=ts"
export * from "./RfidLayout.vue?vue&type=script&lang=ts"
import style1 from "./RfidLayout.vue?vue&type=style&index=1&id=28edc252&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports